import {Modal, Text, Button, Icon} from '@/ui-kits';
import React from 'react';
import { useDispatch } from 'react-redux';
import { followUpConsultationRequest } from '@/services/redux/slices';
import { formatName } from '@/utils/common_functions';

interface FollowupModalProps {
  isOpen: boolean;
  onClose: () => void;
  case_id: number;
  specialist_name: string;
}
export const FollowupModal: React.FC<FollowupModalProps> = props => {
  const {isOpen, onClose, case_id, specialist_name} = props;
  const dispatch = useDispatch();

  const handleBookNow = () => {
    dispatch(followUpConsultationRequest({id: case_id}));
    onClose();
  };

  return (
    <Modal open={isOpen} className="bg-white rounded-xl p-6 flex flex-col gap-6 max-w-[400px] w-full">

      <button onClick={onClose} className="self-end">

      <Icon type="close" className="size-6 max-w-[90%] text-ui_blue " />
      </button>
      <Text className="text-ui_blue !font-FigtreeSemiBold text-center max-w-[95%] w-full" variant="body">You're about to start a follow-up consultation with Dr. {formatName(specialist_name)}.</Text>
      <Button title="Book Now" className="max-w-[220px] w-full self-center" variant="primary" onClick={handleBookNow} />
    </Modal>
  );
};
